module.exports = __webpack_public_path__ + "img/emptyTable.b6c1f943.png";